import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function contratos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@contratos/REQUEST_SUCCESS': {
        draft.data = action.payload.contratos;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
